import { GlobalPageContext } from '../../context/GlobalPageContext';

export const isNonProduction = () => !!GlobalPageContext.get().showFallbackPage;
export const showContentfulLinks = () => !!GlobalPageContext.get().showContentfulLinks;
export const isAvailabilityUndefined = () => GlobalPageContext.get().availability === undefined;
export const isAvailabilityPublic = () => GlobalPageContext.get().availability === 'Public';
export const getAllDataIssues = () => GlobalPageContext.get().dataIssues;
export const getDataPathsMetadata = () => GlobalPageContext.get().dataPathsMetadata;
export const getSpaceId = () => GlobalPageContext.get().spaceId;
export const getEnvironment = () => GlobalPageContext.get().environment;
